export const getLayoutInfo = () => {
  const grid = document.querySelector('#template-group-preview');
  const perPageInput = document.querySelector('input[name="per_page"]');

  return {
    id: grid?.dataset.layoutId,
    customerId: grid?.dataset.customerId,
    name: grid?.dataset.layoutName,
    perPage: perPageInput?.value,
  };
};
